import {
    ADD_TERMINAL_RETAILER_DATA_FAILED, ADD_TERMINAL_RETAILER_DATA_LOADING, ADD_TERMINAL_RETAILER_DATA_SUCCESS
} from "../types";

const initialState = {
    loading: false,
    error: null,
    Retailer: null,
    status: null,
};

export const AddTerminalRetailerReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; status: any; error: any }
) => {
    switch (action.type) {
        case ADD_TERMINAL_RETAILER_DATA_LOADING:
            return {
                ...state,
                loading: action.loading,
            };
        case ADD_TERMINAL_RETAILER_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                Retailer: action.payload,
                status: action.status,
                error: null,
            };
        case ADD_TERMINAL_RETAILER_DATA_FAILED:
            return {
                ...state,
                loading: false,
                Retailer: null,
                status: null,
                error: action.error,
            };
        default:
            return state;
    }
};
